import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthContext } from "../contexts/AuthContext";

const PrivateRoute = ({ element }: any) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const location = useLocation();

  if (isAuthenticated) {
    if (
      user &&
      user.userType === "Buyer" &&
      location.pathname.includes("/admin")
    ) {
      return <Navigate to="/" replace />;
    }
    return element;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default PrivateRoute;
